import {
  Box,
  Paper,
  Table,
  TableBody, TableCell,
  TableContainer,
  TableRow, Typography,
} from '@mui/material';
import React from 'react';
import {SectionHeader} from './header-section';
import {sectionPaperStyling} from './estimate-view-v4';

type BenefitRow = { label: string; value: string };
const benefitRowBorderLabels = new Set([
  'Payer / Plan',
  'Deductible Remaining',
  'Deductible Included in OOPM?',
  'Coinsurance & Copay',
]);

export const BenefitDetailsSection = ({
                                        payorAndPlanName,
                                        deductible,
                                        deductibleRemaining,
                                        oopMax,
                                        oopMaxRemaining,
                                        isDeductibleIncludedInOopMax,
                                        notes,
                                      }: {
  payorAndPlanName: string
  deductible?: number
  deductibleRemaining?: number
  oopMax?: number,
  oopMaxRemaining?: number
  isDeductibleIncludedInOopMax?: boolean
  notes?: string
}) => {
  const benefitRows: BenefitRow[] = [
    {label: 'Payer / Plan', value: payorAndPlanName},
    {
      label: 'Deductible',
      value: typeof deductible === 'number' ? new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(deductible) : '',
    },
    {
      label: 'Deductible Remaining',
      value: typeof deductibleRemaining === 'number' ?
          new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
          }).format(deductibleRemaining) :
          '',
    },
    {
      label: 'Out of Pocket Max',
      value: typeof oopMax === 'number' ? new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(oopMax) : '',
    },
    {
      label: 'Out of Pocket Max Remaining',
      value: typeof oopMaxRemaining === 'number' ?
          new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
          }).format(oopMaxRemaining) :
          '',
    },
    {
      label: 'Deductible Included in OOPM?',
      value: typeof isDeductibleIncludedInOopMax === 'boolean' ?
          isDeductibleIncludedInOopMax ? 'Yes' : 'No' :
          '',
    },
    // {label: 'Coinsurance & Copay', value: '$0.00 / $50.00'},
  ];
  return (
      <Box mb={4}>
        <SectionHeader title="Benefit Details" testId="benefit-details-title"/>
        <TableContainer
            component={Paper}
            sx={{
              mt: 2,
              ...sectionPaperStyling,

            }}
        >
          <Table
              size="small"
              sx={{
                '& td': {borderBottom: 'none'},
              }}
          >
            <TableBody>
              {benefitRows.map(row => {
                const hasBorder = benefitRowBorderLabels.has(row.label);
                return (
                    <TableRow
                        key={row.label}
                        sx={{
                          '& td': {
                            borderBottom: hasBorder
                                ? '1px solid #d0d0d0'
                                : 'none',
                          },
                        }}
                    >
                      <TableCell>{row.label}</TableCell>
                      <TableCell align="right">{row.value}</TableCell>
                    </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        {
            notes && (
                <Box sx={{mt: 2, px: 2}}>
                  <Typography variant="caption" component="div">
                    Notes:
                  </Typography>
                  <Typography variant="caption" component="div">
                    {notes || ''}
                  </Typography>
                </Box>
            )
        }

      </Box>
  );
};